import React, { useState } from 'react';

function LastPosition() {
  const [vehicleId, setVehicleId] = useState(null);
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const schema = localStorage.getItem('schema');

  const fetchLastPosition = async () => {
    if (!vehicleId.trim()) {
      setError('Vehicle ID harus diisi');
      return;
    }

    setLoading(true);
    setError('');
    setPosition(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/proxy.php?id=${encodeURIComponent(vehicleId)}&schema=${schema}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      if (data.error) throw new Error(data.error);

      setPosition(data);
    } catch (err) {
      setError(err.message || 'Gagal ambil data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>📡 Cek Posisi GPS Kendaraan</h3>
      <input
        type="text"
        value={vehicleId}
        onChange={(e) => setVehicleId(e.target.value)}
        placeholder="Masukkan Vehicle ID"
        style={{ padding: 8, width: '100%', marginBottom: 10 }}
      />
      <button onClick={fetchLastPosition}>Ambil Posisi</button>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {position && (
        <div style={{ marginTop: 15, backgroundColor: '#eef', padding: 10, borderRadius: 8 }}>
          <p><strong>Latitude:</strong> {position.latitude}</p>
          <p><strong>Longitude:</strong> {position.longitude}</p>
          <p><strong>Last Update:</strong> {position.lastupdate}</p>
          <a
            href={`https://maps.google.com/?q=${position.latitude},${position.longitude}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            🌍 Lihat di Google Maps
          </a>
        </div>
      )}
    </div>
  );
}

export default LastPosition;
